function OtherMessage({ message }) {
  return (
    <>
      <div className="other-message">
        <div className="other-message__avatar">
          <div className="other-message__avatar-img"></div>
        </div>
        <div className="other-message__bubble">
          <p className="other-message__text">{message}</p>
          <svg
            className="other-message__tail"
            mlns="http://www.w3.org/2000/svg"
            width="8"
            height="18"
            viewBox="0 0 8 18"
            fill="none">
            <path
              d="M0 0C3.36842 4 6.31579 4.22222 8 4V18C5.47368 15.1111 0.842105 10.6667 0 0Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </>
  );
}

export default OtherMessage;
